import { useEffect, useState } from "react";
import PointsMissionsHeaderSection from "./PointsMissionsHeaderSection";
import { missionsTableData } from "../../data/order/missionsTableData";
import PointMissionsSortHeader from "./PointMissionsSortHeader";
import PointMissionsList from "./PointMissionsList";
import { useMilesPoints } from "../../hooks/useMilesPoints";
import CommonPaginationSection from "../common/CommonPaginationSection";

function PointsMissionsSection() {
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10,
    total: 10,
  });
  const { getMissions } = useMilesPoints();
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([]);
  const [ogData, setOgData] = useState([]);
  const [filter, setFilter] = useState("");
  const [sort, setSort] = useState({
    orderBy: "createdAt",
    order: "asc",
  });

  const loadData = () => {
    getMissions({
      setLoading,
      page: pagination.page,
      limit: pagination.perPage,
      callback: (missions, total) => {
        setOgData(missions);
        setOrders(missions.map((reward) => missionsTableData(reward)));
        setPagination((prev) => ({ ...prev, total }));
      },
      filter,
      sort,
    });
  };

  useEffect(() => {
    loadData();
  }, [filter, pagination.page, pagination.perPage, sort]);

  return (
    <div className="flex flex-col w-full">
      <div className="flex flex-col w-full">
        <PointsMissionsHeaderSection
          value={filter}
          onFilterChange={(value) => setFilter(value)}
          callback={(mission) => {
            setOgData([mission, ...ogData]);
            setOrders([missionsTableData(mission), ...orders]);
          }}
        />
        <PointMissionsSortHeader
          onSortChange={setSort}
          sortField={sort.orderBy}
          sortType={sort.order}
        />
        <PointMissionsList
          loading={loading}
          ogData={ogData}
          orders={orders}
          callback={(mission) => {
            const updatedMissions = ogData.map((og) =>
              og._id === mission._id ? mission : og
            );
            setOgData(updatedMissions);
            setOrders(
              updatedMissions.map((mission) => missionsTableData(mission))
            );
          }}
          onDelete={(mission) => {
            const updatedMissions = ogData.filter(
              (og) => og._id !== mission._id
            );
            setOgData(updatedMissions);
            setOrders(
              updatedMissions.map((mission) => missionsTableData(mission))
            );
          }}
        />
        <div className="w-full mt-2">
          <CommonPaginationSection
            perPage={pagination.perPage}
            total={pagination.total}
            page={pagination.page}
            callback={(pg, perPage) =>
              setPagination({ ...pagination, page: pg, perPage })
            }
          />
        </div>
      </div>
    </div>
  );
}

export default PointsMissionsSection;
